import { DistrictList } from "../staticInfo/state";
import {
    BinListAction,
    ChangeBinContractAction,
    ChangeBinEngNameAction,
    ChangeBinHistoryAction,
    ChangeBinNameAction,
    ChangeBinEmailAction,
    ChangeBinRemarkAction,
    ChangeBinStatusAction,
    ChangeBinTypeAction,
    ChangeBincCodeAction,
    ChangeBincLatAction,
    ChangeBincLonAction,
    ChangeDistrictIdAction,
    ClearSelectedBinAction,
    InitBinDetailAction,
    InitBinListAction,
    ChangeBinContactPersonAction,
    ChangeSelectedZoneIdAction,
    ChangeSelectedToiletNumberAction,
    initBinGroupListAction,
} from "./action";
import { BinGroup, BinHisoryList, BinList } from "./state";
import { Dispatch } from "redux";

export function initBinListThunk(binlist: BinList[]) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(InitBinListAction(binlist));
    };
}
export function initBinGroupListThunk(BinGroupList:BinGroup[]){
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(initBinGroupListAction(BinGroupList));
    };
}



export function initBinDetailThunk(binDetail: BinList) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(InitBinDetailAction(binDetail));
    };
}

export function ChangeBinNameThunk(name: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinNameAction(name));
    };
}

export function ChangeBinEngNameThunk(name: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinEngNameAction(name));
    };
}

export function ChangeBinEmailThunk(email: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinEmailAction(email));
    };
}

export function ChangeBinContactPersonThunk(contact_person: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinContactPersonAction(contact_person));
    };
}

export function ChangeBincCodeThunk(name: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBincCodeAction(name));
    };
}

export function ChangeBinLatThunk(lat: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBincLatAction(lat));
    };
}

export function ChangeBinLonThunk(lon: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBincLonAction(lon));
    };
}

export function ChangeBinRemarksThunk(remark: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinRemarkAction(remark));
    };
}

export function ChangeBinContractIdThunk(contract_id: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinContractAction(contract_id));
    };
}

export function ChangeBinDistrictThunk(data: DistrictList) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeDistrictIdAction(data));
    };
}

export function ChangeToiletNumberThunk(toilet_number:string){
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeSelectedToiletNumberAction(toilet_number));
    };
}

export function UpdateBinListThunk(
    binListRootState: BinList[],
    selectedBinItem: BinList
) {
    const newBinList = binListRootState.map((binList) => {
        if (binList.bin_id === selectedBinItem.bin_id) {
            return selectedBinItem;
        }
        return binList;
    });

    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(InitBinListAction(newBinList));
    };
}

export function ChangeBinTypeThunk(bin_type_id: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinTypeAction(bin_type_id));
    };
}

export function ClearSelectedBinThunk() {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ClearSelectedBinAction());
    };
}

export function ChangeBinStatusThunk(status: string) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinStatusAction(status));
    };
}

export function PushBinListThunk(
    binListRootState: BinList[],
    selectedBinItem: BinList
) {
    const updatedBinListRootState = [selectedBinItem, ...binListRootState];

    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(InitBinListAction(updatedBinListRootState));
    };
}

export function initBinHistoryThunk(binHistoryList: BinHisoryList[]) {
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeBinHistoryAction(binHistoryList));
    };
}

export function ChangeSelectedBinZoneThunk(zone_id:number){
    return (dispatch: Dispatch<BinListAction>) => {
        dispatch(ChangeSelectedZoneIdAction(zone_id));
    };
}

